import styled from 'styled-components';

export const ConnectBillingAddressWrapper = styled.div`
  width: 100%;
  margin-top: 15px;
`;
